function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import PaginationItem from "../PaginationItem";
import PaginationLink from "../PaginationLink";
/**
 * A clickable link to the first/previous/next/last page in the pagination bar
 */

var ShortcutLink = function ShortcutLink(_ref) {
  var page = _ref.page,
      children = _ref.children,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["page", "children", "disabled"]);

  var onClick = function onClick(event) {
    event.preventDefault();
    props.onClick(page);
  };

  return (
    /*#__PURE__*/
    React.createElement(PaginationItem, {
      disabled: disabled
    },
    /*#__PURE__*/
    React.createElement(PaginationLink, {
      onClick: onClick,
      tabIndex: disabled ? -1 : undefined
    }, children))
  );
};

ShortcutLink.displayName = "ShortcutLink";
ShortcutLink.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  name: PropTypes.string
};
export default ShortcutLink;